import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

/*
 * SveTech chip (Key design „Chip/štítok“): `svt-spec`, radius 5 with the square top-right corner,
 * flat; `default` = light green with ink text, the other variants on the recipe's soft surfaces.
 */
const badgeVariants = cva(
  'svt-spec inline-flex cursor-default items-center border border-transparent transition-colors focus:outline-none',
  {
    variants: {
      variant: {
        default: 'bg-[#b2d6aa] text-[#14171a]',
        accent: 'bg-[#f1c40f] text-[#14171a]',
        secondary: 'bg-[#f2f3ef] text-[#14171a]',
        destructive: 'bg-[#fdecea] text-[#b3261e]',
        outline: 'border-[#dfe2db] text-[#14171a]',
      },
      size: {
        default: 'rounded-[5px] rounded-tr-none px-3 py-1',
        sm: 'rounded-[4px] rounded-tr-none px-[5px] py-[2px] leading-3',
        md: 'rounded-[5px] rounded-tr-none px-2 py-[1px] leading-4',
        circle: 'h-6 w-6 justify-center rounded-full text-[10px]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant, size, className }))} {...props} />;
}

export { Badge, badgeVariants };
